<p-icon class="suggestion-icon" [name]="iconName"></p-icon>
<span class="suggestion-text">{{ label }}</span>
